import { PermissionT } from "../types";

export const enterpriseManager = (permissions: PermissionT[]): boolean =>
  permissions.some((permission) => permission.name === "enterprise_manager");

export default enterpriseManager;
